Ext.define('SA.model.createimport.NumericDataValidator', {
    statics: {
        getErrorsForTupleList(tupleList) {
            var validators = tupleList.map(tuple => new SA.model.createimport.NumericDataValidator(tuple)),
                hasNonNumericData = validator => validator.hasNonNumericData(),
                getError = validator => validator.getError();

            return validators.filter(hasNonNumericData).map(getError);
        },

        isNumeric(value) {
            return /^-?(?:(?:\d+)|(?:\d+\.\d+)|(?:\.\d+)|(?:\d+\.))$/.test(value);
        }
    },

    constructor(tuple) {
        this.tuple = tuple;
    },

    getError() {
        var fileName = this.tuple.getFileName(),
            headerNames = this.getInvalidColumnHeaderNames();

        return {fileName, headerNames};
    },

    getInvalidColumnHeaderNames() {
        if (this.headerNames) {
            return this.headerNames;
        }

        var headerNames = this.headerNames = [],
            columns = this.tuple.getDataColumns(),
            isNumeric = value => this.self.isNumeric(value);

        columns.forEach(({headerName, values}) => {
            Ext.Array.each(values, value => {
                if (value && !isNumeric(value)) {
                    headerNames.push(headerName);

                    return false; 
                }
            });
        });

        return headerNames;
    },

    hasNonNumericData() {
        return !!this.getInvalidColumnHeaderNames().length;
    }
});